import * as React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import ReviewSummary, {
  ReviewSection,
} from 'components/ReportRequestV2/ReviewSummary';

interface Props {
  open: boolean;
  title: string;
  projectName?: string;
  /** Read-only recap of the form, so the request can be checked in one place. */
  sections: ReviewSection[];
  onCancel: () => void;
  onConfirm: () => void;
  submitting?: boolean;
}

/** Last chance before an expensive compute job starts. */
const ConfirmSubmitDialog: React.FC<Props> = ({
  open,
  title,
  projectName,
  sections,
  onCancel,
  onConfirm,
  submitting = false,
}) => (
  <Dialog
    open={open}
    onClose={onCancel}
    aria-labelledby="confirm-submit-title"
    maxWidth="md"
    fullWidth
  >
    <DialogTitle id="confirm-submit-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText sx={{ mb: 2 }}>
        Submitting starts a compute job for “{projectName}”. Jobs are expensive
        and cannot be cancelled from here, so check the summary below before
        continuing.
      </DialogContentText>
      <ReviewSummary sections={sections} />
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Keep editing</Button>
      <Button
        variant="contained"
        onClick={onConfirm}
        disabled={submitting}
        autoFocus
      >
        Submit
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmSubmitDialog;
